/* === KITE: Auto-expand gift widget on load === */
(function () {
  var observer = new MutationObserver(function (mutations, obs) {
    var kiteToggle = document.querySelector('.gfgFreeGiftSelectDiv');
    if (kiteToggle) {
      obs.disconnect();
      if (!kiteToggle.classList.contains('gfgFreeGiftSelectDivExpanded')) {
        kiteToggle.click();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();